import { theme, Modal, Spin } from "antd";

const App = ({ isStatusModalOpen }) => {
  const { token } = theme.useToken();
  const contentStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "160px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  return (
    <>
      <Modal
        title="Processing"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isStatusModalOpen}
        footer={false}
        width={1000}
      >
        <div style={{ marginTop: "20px" }}>
          <div style={contentStyle}>
            <div style={{ marginBottom: "20px" }}>
              <Spin />
            </div>
            Generating and saving the data structure. Please wait...
          </div>
        </div>
      </Modal>
    </>
  );
};

export default App;
